export const CasterVoiceTypes = {
	MALE: 'MALE',
	FEMALE: 'FEMALE',
};

export const CasterVoiceTypesTranslations = {
	MALE: 'MASCULINA',
	FEMALE: 'FEMININA',
};
